(function () {
	// Get all of the widget menus in WordPress
	const widgetMenus = document.querySelectorAll('.widget_nav_menu');
	if (!widgetMenus) return;

	class AnchorMenus {
		constructor(menu) {
			this.menu = menu;
			this.menuItems = Array.from(this.menu.querySelectorAll('.menu-item'));
			this.menuItemAnchors = this.menu.querySelectorAll('a[href*="#"]');
		}

		init() {
			const isActive =
				this.menuItems.filter(
					item => item.classList.contains('current-menu-item') && this.menuItemAnchors.length > 0
				).length > 0;
			if (isActive) {
				this.menuItemAnchors.forEach(anchor => {
					const menuItem = anchor.matches('li') ? anchor : anchor.closest('li');
					menuItem.classList.toggle(
						'current-menu-item',
						anchor.hash.substring(1) === window.location.hash.substring(1)
					);
					anchor.addEventListener('click', e => {
						e.preventDefault();
					});
				});
				window.addEventListener('hashchange', () => {
					this.menuItemAnchors.forEach(anchor => {
						const menuItem = anchor.matches('li') ? anchor : anchor.closest('li');
						menuItem.classList.toggle(
							'current-menu-item',
							anchor.hash.substring(1) === window.location.hash.substring(1)
						);
					});
				});
			}
		}
	}

	widgetMenus.forEach(menu => {
		const menuInstance = new AnchorMenus(menu);
		menuInstance.init();
	});
})();

(function () {
	// Get all of the widget menus in WordPress
	// const widgetMenus = document.querySelectorAll('.widget_nav_menu');
	const widgetMenus = document.querySelector('.site-header__menu');
	if (!widgetMenus) return;

	class AnchorMenus {
		constructor(menu) {
			this.menu = menu;
			this.menuItems = Array.from(this.menu.querySelectorAll('.menu-item'));
			this.menuItemAnchors = this.menu.querySelectorAll('a[href*="#"]');
		}

		setInitialActive() {
			// Get the current hash
			const hash = window.location.hash.substring(1);
			// Check if the hash is empty
			if (hash === '') return;
			// Get the anchor with the hash
			const anchor = this.menu.querySelector(`a[href="#${hash}"]`);
			// Check if the anchor exists
			if (anchor === null) return;
			// Get the anchor's parent
			const menuItem = anchor.closest('li');
			// Check if the parent exists
			if (menuItem === null) return;
			// Add the active class to the parent
			menuItem.classList.add('current-menu-item');
		}

		init() {
			this.setInitialActive();
			const isActive =
				this.menuItems.filter(
					item => item.classList.contains('current-menu-item') && this.menuItemAnchors.length > 0
				).length > 0;
			if (isActive) {
				this.menuItemAnchors.forEach(anchor => {
					const menuItem = anchor.matches('li') ? anchor : anchor.closest('li');
					menuItem.classList.toggle(
						'current-menu-item',
						anchor.hash.substring(1) === window.location.hash.substring(1)
					);
					anchor.addEventListener('click', e => {
						e.preventDefault();
					});
				});
				window.addEventListener('hashchange', () => {
					this.menuItemAnchors.forEach(anchor => {
						const menuItem = anchor.matches('li') ? anchor : anchor.closest('li');
						menuItem.classList.toggle(
							'current-menu-item',
							anchor.hash.substring(1) === window.location.hash.substring(1)
						);
					});
				});
			}
		}
	}

	new AnchorMenus(widgetMenus).init();
})();
